// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/global/custom.scss
// module id = 982
// module chunks = 0